import { __awaiter, __generator } from "tslib";
var PyramidEmbedClient = /** @class */ (function () {
    function PyramidEmbedClient(host, userName, password, customData) {
        if (!host)
            throw Error("host can't be empty");
        this._host = getActualHost(host);
        this.init(userName, password, customData);
    }
    Object.defineProperty(PyramidEmbedClient.prototype, "host", {
        get: function () {
            return this._host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PyramidEmbedClient.prototype, "isClientLoaded", {
        get: function () {
            return clientLoaded();
        },
        enumerable: true,
        configurable: true
    });
    PyramidEmbedClient.quickEmbed = function (options) {
        var instance = new PyramidEmbedClient(options.host);
        instance.init(options.userName, options.password, options.customData).then(function () {
            instance.embed(options.container, options);
        });
        return instance;
    };
    PyramidEmbedClient.prototype.init = function (userName, password, customData) {
        var _this = this;
        if (this.isClientLoaded && this.isLoggedIn) {
            return Promise.resolve(null);
        }
        if ((!userName || !password) && !this.isLoggedIn) {
            //throw error?
            return Promise.resolve(null);
        }
        if (!this.isLoggedIn)
            return this.login(userName, password, customData).then(function (token) {
                getLegacyEmbed(_this.host.toString());
                return token;
            });
        else {
            getLegacyEmbed(this.host.toString());
            return Promise.resolve(null);
        }
    };
    PyramidEmbedClient.prototype.setAuthToken = function (token) {
        this.setTokenCookie(token);
    };
    PyramidEmbedClient.prototype.getAuthToken = function () {
        if (this.hasCookie()) {
            return this.getTokenCookie();
        }
        return null;
    };
    PyramidEmbedClient.prototype.setAuthFailureCallback = function (callback) {
        var _this = this;
        if (!this.isClientLoaded) {
            //wait for script to load
            setTimeout(function () { return _this.setAuthFailureCallback(callback); }, 200);
            return;
        }
        pyramid.authFailure = callback;
    };
    //legacy embed. keep as is
    PyramidEmbedClient.prototype.embed = function (container, options) {
        var _this = this;
        var _a, _b;
        if (!this.isClientLoaded) {
            //wait for script to load
            setTimeout(function () { return _this.embed(container, options); }, 200);
            return;
        }
        var params = {
            reportFilters: (_a = options.filters) === null || _a === void 0 ? void 0 : _a.toGlobalEmbedFilters(),
            targets: (_b = options.targets) === null || _b === void 0 ? void 0 : _b.toGlobalEmbedTarget(),
        };
        pyramid.embed(container, {
            id: options.contentId,
            contentType: options.visualOnly ? 'visual' : null,
            //remove trailing slash
            host: this.host.href.replace(/\/$/, ''),
            onLoad: options.onLoad,
            params: params,
            deviceType: options.deviceType,
        });
    };
    PyramidEmbedClient.prototype.login = function (userName, password, customData) {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = {
                            data: {
                                userName: userName,
                                password: password,
                                domain: document.domain,
                                customData: customData,
                            },
                        };
                        return [4 /*yield*/, this.loginInternal(this.host.href + "API2/auth/authenticateUserEmbed", {
                                method: 'POST',
                                body: JSON.stringify(credentials),
                            })];
                    case 1:
                        token = _a.sent();
                        this.setTokenCookie(token);
                        return [2 /*return*/, token];
                }
            });
        });
    };
    PyramidEmbedClient.prototype.loginWindowsAuth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = { data: { domain: document.domain } };
                        return [4 /*yield*/, this.loginInternal(this.host.href + "API2/auth/authenticateUserEmbedWindows", {
                                method: 'POST',
                                credentials: 'include',
                                body: JSON.stringify(credentials),
                            })];
                    case 1:
                        token = _a.sent();
                        this.setTokenCookie(token);
                        return [2 /*return*/, token];
                }
            });
        });
    };
    PyramidEmbedClient.prototype.loginSamlAuth = function (samlToken) {
        return __awaiter(this, void 0, void 0, function () {
            var credentials, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        credentials = { data: { domain: document.domain, token: samlToken } };
                        return [4 /*yield*/, this.loginInternal(this.host.href + "API2/auth/authenticateUserEmbedSAML", {
                                method: 'POST',
                                body: JSON.stringify(credentials),
                            })];
                    case 1:
                        token = _a.sent();
                        this.setTokenCookie(token);
                        return [2 /*return*/, token];
                }
            });
        });
    };
    PyramidEmbedClient.prototype.loginInternal = function (requestInfo, requestInit) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage, response, token, error_1, errorMsg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        return [4 /*yield*/, fetch(requestInfo, requestInit)];
                    case 1:
                        response = _b.sent();
                        if (!!response) return [3 /*break*/, 2];
                        errorMessage = 'Unknown Login Error';
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(response.status === 401)) return [3 /*break*/, 3];
                        errorMessage = 'Login failed';
                        return [3 /*break*/, 6];
                    case 3:
                        if (!(response.status !== 200)) return [3 /*break*/, 4];
                        errorMessage = 'Unknown Login Error';
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, response.text()];
                    case 5:
                        token = _b.sent();
                        return [2 /*return*/, token];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        error_1 = _b.sent();
                        errorMsg = typeof error_1 === 'string' ? error_1 : (_a = error_1) === null || _a === void 0 ? void 0 : _a.message;
                        errorMessage = "Login Error: " + errorMsg;
                        return [3 /*break*/, 8];
                    case 8:
                        if (errorMessage) {
                            throw new Error(errorMessage);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PyramidEmbedClient.prototype, "isLoggedIn", {
        get: function () {
            return this.hasCookie();
        },
        enumerable: true,
        configurable: true
    });
    PyramidEmbedClient.prototype.hasCookie = function () {
        var _a;
        return ((_a = document.cookie.match(/^(.*;)?\s*PyramidEmbeddedAuth\s*=\s*[^;]+(.*)?$/)) === null || _a === void 0 ? void 0 : _a.length) > 0;
    };
    PyramidEmbedClient.prototype.setTokenCookie = function (val) {
        document.cookie = "PyramidEmbeddedAuth=" + val;
    };
    PyramidEmbedClient.prototype.getTokenCookie = function () {
        var name = 'PyramidEmbeddedAuth=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
    return PyramidEmbedClient;
}());
export { PyramidEmbedClient };
function getActualHost(host) {
    var actualHost = !host.startsWith('http://') && !host.startsWith('https://') ? "http://" + host : host;
    return new URL(actualHost);
}
function getLegacyEmbed(host) {
    if (clientLoaded())
        return;
    var headExists = false;
    Array.from(document.querySelectorAll('script')).forEach(function (x) {
        var _a;
        if ((_a = x.src) === null || _a === void 0 ? void 0 : _a.includes('no-shell/embed.js')) {
            headExists = true;
        }
    });
    if (!headExists) {
        var scriptElem = document.createElement('script');
        scriptElem.src = host + "no-shell/embed.js";
        scriptElem.async = true;
        document.head.appendChild(scriptElem);
    }
}
function tryLoadStaticEmbed() {
    var staticEmbedElement = document.querySelector('.pyramid-embed.pyramid-auto[data-host]');
    if (staticEmbedElement) {
        getLegacyEmbed(getActualHost(staticEmbedElement.getAttribute('data-host')).toString());
    }
}
function clientLoaded() {
    return window.pyramid != null;
}
document.addEventListener('DOMContentLoaded', function (event) {
    tryLoadStaticEmbed();
});
